import React, { createContext, useContext, useState } from "react";
const PaginationContext = createContext(null);
const PaginationUpdateContext = createContext(null);
export function PaginationProvider({
  initPage = 1,
  initPerPage = 10,
  initFilters = {},
  initQuery = null,
  initOrderBy = void 0,
  initDirection = void 0,
  children
}) {
  const [localPagination, setLocalPagination] = useState({
    page: initPage,
    perPage: initPerPage,
    query: initQuery,
    orderBy: initOrderBy,
    direction: initDirection,
    filters: initFilters
  });
  return /* @__PURE__ */ React.createElement(PaginationContext.Provider, { value: localPagination }, /* @__PURE__ */ React.createElement(PaginationUpdateContext.Provider, { value: setLocalPagination }, children));
}
export function usePagination() {
  return useContext(PaginationContext);
}
export function useSetPagination() {
  return useContext(PaginationUpdateContext);
}
